export default function companyValuesList(el: HTMLElement) {
  const items: NodeListOf<HTMLElement> = el.querySelectorAll(
    ".company-values-item"
  )

  function openSingleDetail() {
    items.forEach(activeItem => {
      activeItem.addEventListener("click", () => {
        items.forEach(item => {
          if (item !== activeItem) {
            resetActiveState(item)
          }
        })
      })
    })
  }

  const mediaQuery = window.matchMedia("(min-width: 1200px)")

  mediaQuery.addEventListener("change", init)
  init()
  openSingleDetail()

  function init() {
    // adjust layout for desktop
    el.querySelector(".company-values__list-container")?.classList.remove(
      "desktop:col-end-full"
    )

    items.forEach(item => {
      // hide the description and chevron elements on desktop
      item.parentNode
        ?.querySelector(".company-values-description")
        ?.classList.add("desktop:sr-only")

      item
        .querySelector(".company-values-item__chevron")
        ?.classList.add("desktop:hidden")

      // now that the chevron is hidden, adjust the alignment for desktop
      item.classList.add("desktop:justify-start")
    })

    if (mediaQuery.matches) {
      items.forEach(item => {
        resetActiveState(item)
        item.addEventListener("click", addActiveClass, false)
      })

      const firstItem = items[0]
      if (firstItem) {
        firstItem.classList.add("company-values-item--active")
        const firstDetailsEl =
          firstItem.parentElement as HTMLDetailsElement | null
        if (firstDetailsEl) {
          firstDetailsEl.open = true
        }
        showDescription(firstItem)
      }
    } else {
      items.forEach(item => {
        resetActiveState(item)
      })
    }
  }

  function addActiveClass(e: Event) {
    const item: HTMLElement = e.currentTarget as HTMLElement
    const activeEl: HTMLElement | null = el.querySelector(
      ".company-values-item--active"
    )
    if (activeEl) {
      activeEl.classList.remove("company-values-item--active")
    }
    item.classList.add("company-values-item--active")
    showDescription(item)
  }

  function resetActiveState(item: HTMLElement) {
    const detailsEl = item.parentElement as HTMLDetailsElement
    detailsEl.removeAttribute("open")
    item.classList.remove("company-values-item--active")
  }

  function showDescription(item: HTMLElement) {
    const activeParentEl: HTMLElement | null = item.parentElement
    if (!activeParentEl) {
      return
    }
    const activeDescription = activeParentEl.querySelector(
      ".company-values-description"
    )
    if (!activeDescription) {
      return
    }
    const activeDescriptionText: string = activeDescription.innerHTML
    const descriptionContainer: HTMLElement | null = el.querySelector(
      ".company-values-box"
    )
    if (!descriptionContainer) {
      return
    }
    descriptionContainer.innerHTML = activeDescriptionText
  }
}
